document.addEventListener("DOMContentLoaded", function () {
  const maxViewportWidth = 2560;
  const slideDuration = 10;

  document.querySelectorAll(".difference-page-slider-container").forEach((sliderContainer, sliderIndex) => {
    const slides = sliderContainer.querySelectorAll(".difference-slide");
    const totalSlides = slides.length;
    const realSlidesCount = totalSlides - 2;
    let currentSlide = 1;
    let autoSlideInterval = null;
    let isPaused = false;

    // Fade-in effect for images inside this slider only
    sliderContainer.querySelectorAll('.fade-in-image').forEach(image => {
      image.addEventListener('load', () => image.classList.add('loaded'));
      if (image.complete) image.classList.add('loaded');
    });

    function updateSlidePosition() {
      const viewportWidth = Math.min(window.innerWidth, maxViewportWidth);
      gsap.set(sliderContainer, { x: -currentSlide * viewportWidth });
    }

    setTimeout(() => {
      sliderContainer.querySelectorAll(".difference-slide:not(.difference-slide-1)").forEach(slide => {
        slide.style.visibility = "visible";
      });
    }, 1000);

    function moveToSlide(index, animate = true) {
      const viewportWidth = Math.min(window.innerWidth, maxViewportWidth);
      const targetX = -index * viewportWidth;

      gsap.to(sliderContainer, {
        x: targetX,
        duration: animate ? 1 : 0,
        ease: "power2.inOut",
        onComplete: handleEdgeCases,
      });

      currentSlide = index;
      sliderContainer.dataset.currentSlide = index;
    }

    function handleEdgeCases() {
      if (currentSlide === 0) {
        currentSlide = realSlidesCount;
        updateSlidePosition();
      } else if (currentSlide === totalSlides - 1) {
        currentSlide = 1;
        updateSlidePosition();
      }
    }

    function startAutoSlide() {
      if (!isPaused && !autoSlideInterval) {
        autoSlideInterval = setInterval(() => {
          moveToSlide(currentSlide + 1);
        }, slideDuration * 1000);
      }
    }

    function stopAutoSlide() {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
        autoSlideInterval = null;
      }
    }

    function resetSlidePositionIfOutOfBounds() {
      const viewportWidth = Math.min(window.innerWidth, maxViewportWidth);
      const currentX = parseFloat(gsap.getProperty(sliderContainer, "x"));
      if (currentX < -(totalSlides - 1) * viewportWidth || currentX > 0) {
        updateSlidePosition();
      }
    }

    // Button handlers scoped to this slider
    sliderContainer.querySelectorAll(".difference-page-slider-button.previous").forEach(button => {
      button.addEventListener("click", function () {
        stopAutoSlide();
        moveToSlide(currentSlide - 1);
        startAutoSlide();
      });
    });

    sliderContainer.querySelectorAll(".difference-page-slider-button.next").forEach(button => {
      button.addEventListener("click", function () {
        stopAutoSlide();
        moveToSlide(currentSlide + 1);
        startAutoSlide();
      });
    });

    // Draggable scoped to this slider
    Draggable.create(sliderContainer, {
      type: "x",
      edgeResistance: 0.85,
      inertia: true,
      onDragStart: stopAutoSlide,
      onDragEnd: function () {
        const viewportWidth = Math.min(window.innerWidth, maxViewportWidth);
        const slideIndex = Math.round(-this.x / viewportWidth);
        moveToSlide(slideIndex);
        startAutoSlide();
      },
      onDrag: function () {
        const viewportWidth = Math.min(window.innerWidth, maxViewportWidth);
        if (this.x > 0) {
          currentSlide = realSlidesCount;
          updateSlidePosition();
          this.endDrag();
        } else if (this.x < -(totalSlides - 1) * viewportWidth) {
          currentSlide = 1;
          updateSlidePosition();
          this.endDrag();
        }
      }
    });

    // Resize and visibility scoped to this slider
    window.addEventListener("resize", updateSlidePosition);

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        isPaused = true;
        stopAutoSlide();
      } else {
        isPaused = false;
        startAutoSlide();
      }
    });

    updateSlidePosition();
    startAutoSlide();
    setInterval(resetSlidePositionIfOutOfBounds, 5000);
  });
});
function showAboutUsText(index) {
  document.querySelectorAll('[class^="about-us-text"]').forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transition = 'opacity 0.5s ease-in-out';
    el.style.display = 'none';
  });

  const visibleText = document.querySelector(`.about-us-text-${index + 1}`);
  if (visibleText) {
    visibleText.style.display = 'block';
    requestAnimationFrame(() => {
      visibleText.style.opacity = '1';
    });
  }
}